export const PROMO_TYPES = [
  { id: 'produk_baru', label: 'Produk Baru' },
  { id: 'flash_sale', label: 'Flash Sale' },
  { id: 'promo_diskon', label: 'Promo Diskon' },
  { id: 'best_seller', label: 'Best Seller' },
  { id: 'promo_mingguan', label: 'Promo Mingguan' },
  { id: 'promo_bulanan', label: 'Promo Bulanan' },
  { id: 'hari_raya', label: 'Hari Raya' },
  { id: 'payday', label: 'Payday' },
  { id: 'promo_terbatas', label: 'Promo Terbatas' },
  { id: 'promo_gratis_ongkir', label: 'Promo Gratis Ongkir' },
] as const

export type PromoTypeId = (typeof PROMO_TYPES)[number]['id']

export const BANNER_SIZES = {
  instagram_feed: { width: 1080, height: 1080, label: 'Instagram Feed' },
  instagram_portrait: { width: 1080, height: 1350, label: 'Instagram Portrait' },
  instagram_story: { width: 1080, height: 1920, label: 'Instagram Story' },
  whatsapp_story: { width: 1080, height: 1920, label: 'WhatsApp Story' },
  facebook: { width: 1200, height: 630, label: 'Facebook' },
  tiktok: { width: 1080, height: 1920, label: 'TikTok' },
  linkedin: { width: 1200, height: 627, label: 'LinkedIn' },
} as const

export type BannerSizeId = keyof typeof BANNER_SIZES

export type BannerLayout =
  | 'gradient-hero'
  | 'split-left'
  | 'split-right'
  | 'centered-minimal'
  | 'diagonal-stripe'
  | 'bold-frame'
  | 'circle-product'
  | 'bottom-bar'
  | 'top-badge'
  | 'dark-overlay'
  | 'light-clean'
  | 'festive-gold'
  | 'sale-strike'
  | 'grid-accent'
  | 'wave-bottom'

export type BannerTemplate = {
  id: string
  name: string
  category: string
  layout: BannerLayout
  variant: number
}

const LAYOUTS: Array<{ layout: BannerLayout; names: string[] }> = [
  { layout: 'gradient-hero', names: ['Gradient Hero', 'Sunset Glow', 'Ocean Wave'] },
  { layout: 'split-left', names: ['Split Kiri', 'Showcase Kiri', 'Produk Kiri'] },
  { layout: 'split-right', names: ['Split Kanan', 'Showcase Kanan', 'Produk Kanan'] },
  { layout: 'centered-minimal', names: ['Minimal Center', 'Clean Focus', 'Simple Bold'] },
  { layout: 'diagonal-stripe', names: ['Diagonal Stripe', 'Slash Promo', 'Dynamic Angle'] },
  { layout: 'bold-frame', names: ['Bold Frame', 'Thick Border', 'Frame Pro'] },
  { layout: 'circle-product', names: ['Circle Product', 'Round Focus', 'Spotlight'] },
  { layout: 'bottom-bar', names: ['Bottom Bar', 'Info Strip', 'Footer Promo'] },
  { layout: 'top-badge', names: ['Top Badge', 'Ribbon Sale', 'Header Deal'] },
  { layout: 'dark-overlay', names: ['Dark Overlay', 'Night Mode', 'Cinematic'] },
  { layout: 'light-clean', names: ['Light Clean', 'Fresh White', 'Bright Day'] },
  { layout: 'festive-gold', names: ['Festive Gold', 'Hari Raya', 'Celebration'] },
  { layout: 'sale-strike', names: ['Sale Strike', 'Harga Coret', 'Discount Bold'] },
  { layout: 'grid-accent', names: ['Grid Accent', 'Modern Grid', 'Tile Style'] },
  { layout: 'wave-bottom', names: ['Wave Bottom', 'Flow Curve', 'Soft Wave'] },
]

export const BANNER_TEMPLATES: BannerTemplate[] = LAYOUTS.flatMap(({ layout, names }) =>
  names.map((name, idx) => ({
    id: `${layout}-v${idx + 1}`,
    name,
    category: layout.split('-')[0],
    layout,
    variant: idx + 1,
  }))
)

export const AI_BANNER_STYLES = [
  { id: 'modern', label: 'Modern' },
  { id: 'minimalis', label: 'Minimalis' },
  { id: 'premium', label: 'Premium' },
  { id: 'kuliner', label: 'Kuliner' },
  { id: 'fashion', label: 'Fashion' },
  { id: 'natural', label: 'Natural' },
  { id: 'luxury', label: 'Luxury' },
] as const

export const COPYWRITER_PLATFORMS = ['Instagram', 'Facebook', 'WhatsApp', 'TikTok', 'LinkedIn'] as const
export const COPYWRITER_TONES = ['Ramah & Santai', 'Profesional', 'Gen Z', 'Persuasif', 'Informatif'] as const

export const AI_BOOST_COSTS = {
  caption: 1,
  banner: 1,
  campaign: 2,
  planner: 1,
  calendar: 1,
} as const

export const MARKETING_NAV = [
  { to: '/marketing', label: 'Dashboard', icon: 'LayoutDashboard' },
  { to: '/marketing/campaign', label: 'Campaign', icon: 'Megaphone' },
  { to: '/marketing/banner', label: 'Banner Promosi', icon: 'Image' },
  { to: '/marketing/copywriter', label: 'AI Copywriter', icon: 'PenLine' },
  { to: '/marketing/calendar', label: 'Kalender Konten', icon: 'Calendar', premium: true },
  { to: '/marketing/planner', label: 'Marketing Planner', icon: 'Lightbulb', premium: true },
  { to: '/marketing/history', label: 'Riwayat Promosi', icon: 'History' },
  { to: '/marketing/analytics', label: 'Analytics', icon: 'BarChart3', premium: true },
  { to: '/marketing/ai-boost', label: 'AI Boost Store', icon: 'Zap' },
] as const
